import type { HistoryStakesPeriod, SavedCashOutErrors, StakesFromBackend } from './types';

import { URL } from '../../constants';
import type { ServiceConfig } from '../../utils/create-http-api-service';
import { defaultRequestService } from '../../utils/default-request-service';
import { transformActiveStakes } from './transform-active-stakes';

export const fetchActiveStakes = (
  config: ServiceConfig,
  savedCashOutErrors?: SavedCashOutErrors,
) => {
  type AdapterProps = { response: StakesFromBackend };

  type TransformActiveStakes = ReturnType<ReturnType<typeof transformActiveStakes>>;

  return defaultRequestService<AdapterProps, TransformActiveStakes>(
    URL.ACTIVE_STAKES,
    config.instance.get,
    {
      responseHandler: transformActiveStakes(savedCashOutErrors),
    },
  );
};

export const fetchHistoryStakes = (
  config: ServiceConfig,
  period: HistoryStakesPeriod,
) => {
  type AdapterProps = { response: StakesFromBackend };
  const url = `${URL.HISTORY_STAKES}?startDate=${period.from.toISOString()}&endDate=${period.till.toISOString()}`;
  return defaultRequestService<AdapterProps>(url, config.instance.get);
};
